export default __webpack_public_path__ + "static/blob13-8c9dd1ccaee4be4d440ff90b763e17fc.svg";